import getVideoId from 'get-video-id';

const fragmentFromString = (html: string) => document.createRange().createContextualFragment(html);

/*
  Minimum markup requirements for Tiktok embed.js to identify node:
   - must be a `<blockquote>`
   - `tiktok-embed` class
   - `[cite]` attr
   - `[data-video-id]` attr
*/
const template = ({
  id,
  url,
  unEnhancedElement,
}: {
  id: string;
  url: string;
  unEnhancedElement: Element;
}) =>
  fragmentFromString(`
  <blockquote
    class="tiktok-embed focuswriter-tiktokembed-player"
    cite="${url}"
    data-video-id="${id}"
  >
    ${unEnhancedElement.outerHTML /* If Tiktok script fails, fallback to un-enhanced element */}
  </blockquote>
`);

const enhanceFocuswriterTiktokEmbed = () => {
  const elementMatches = document.querySelectorAll('[data-focuswriter-tiktokembed]');

  if (
    elementMatches.length &&
    !document.querySelectorAll('script[src="https://www.tiktok.com/embed.js"]').length
  ) {
    document.head.appendChild(
      fragmentFromString('<script async src="https://www.tiktok.com/embed.js"></script>'),
    );
  }

  elementMatches.forEach((prevElement) => {
    const url = prevElement.getAttribute('data-focuswriter-tiktokembed');
    if (!url) return;

    const { id, service } = getVideoId(url);
    if (!id || service !== 'tiktok') return;

    const nextElement = template({
      id,
      url: encodeURI(url),
      unEnhancedElement: prevElement,
    });
    prevElement.replaceWith(nextElement);
  });
};

export default enhanceFocuswriterTiktokEmbed;
